/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1458
 */

var r = require(/* 2553 */"./2553")
var i = require(/* 1176 */"../../../../../../797/101/2466/1436/1176/index")
var o = require(/* 1174 */"./1174")
module.exports = function (e) {
  return "function" != typeof e.constructor || o(e) ? {} : r(i(e))
}
